import React from "react";

function JobJsonLd({ jobDetails }) {
  function addJobJsonLd() {
    return {
      __html: `
            {
                "@context" : "https://schema.org/",
                "@type" : "JobPosting",
                "title" : "${jobDetails.title}",
                "description" : ${JSON.stringify(jobDetails.job_information)},
                "identifier": {
                    "@type": "PropertyValue",
                    "name": "Update Tech Ltd.",
                    "value": "312942245"
                },
                "datePosted" : "${jobDetails.created_at}",
                "validThrough" : "${jobDetails.last_date}",
                "employmentType" : "FULL_TIME",
                "hiringOrganization" : {
                    "@type" : "Organization",
                    "name" : "Update Tech Ltd.",
                    "sameAs" : "https://www.updatetechltd.com",
                    "logo" : "https://updatetechltd.com/icon-256x256.png"
                },
                "jobLocation": {
                    "@type": "Place",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "House: 1240, Road: 9, Avenue: 2, Floor: 3rd, Mirpur DOHS, Dhaka-1216",
                        "addressLocality": "Dhaka",
                        "addressRegion": "Dhaka",
                        "postalCode": "1216",
                        "addressCountry": "BD"
                    }
                }
            }
            `,
    };
  }

  return (
    <>
      <link />
      {jobDetails && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={addJobJsonLd()}
          key="product-jsonld"
        />
      )}
    </>
  );
}

export default JobJsonLd;
